import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import confirmCompleteAssessmentDialog from '../dialog.confirmCompleteAssessmentDialog';
import assessmentNameMessagesTpl from './messages/assessment.name.messages.html';
import controller from './perform-assessment-dialog.controller';
import template from './perform-assessment-dialog.html';


class dialogService {
  getOptions($event, { resumedAssessment }) {
    return {
      controller,
      controllerAs: 'performAssessmentDialogVM',
      locals: {
        resumedAssessment
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.performAssessmentDialog', [
  alerts,
  confirmCompleteAssessmentDialog,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
])
  .service('performAssessmentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.name.messages.html', assessmentNameMessagesTpl);
  })
  .name;
